<template>
    <div class="context common_table_view" ref="common_table_view">
        <div class="header" ref="header">
            <div class="search search_box">
                <el-form :model="searchForm"
                         class="search_form"
                         inline
                         size="small">
                    <el-form-item label="医院名称:">
                        <div class="radio_box">
                            <el-input class="width_220"
                                      @change="getTableData()"
                                      clearable
                                      v-model="searchForm.input">
                            </el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="省市:">
                        <el-cascader size="small"
                                     class="width_220"
                                     placeholder="请选择省市"
                                     clearable
                                     v-model="searchForm.hos_search_cascader"
                                     :options="city_list"
                                     :props="cascader_props"
                                     @change="getTableData()"></el-cascader>
                    </el-form-item>

                    <el-form-item>
                        <div class="search_btn">
                            <el-button type="primary"
                                       @click="getTableData()">
                                搜索
                            </el-button>
                        </div>
                    </el-form-item>

                </el-form>
            </div>
            <div class="btn_box">
                <el-button type="primary"
                           @click="addHos"
                           size="small">
                    添加医院
                </el-button>
            </div>
        </div>

        <div class="table">
            <el-table :data="tableData"
                      stripe
                      width="100%"
                      height="100%">
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="table_btn"
                               @click="editRow(scope.row)">
                            <i class="el-icon-edit"></i>
                            编辑
                        </span>
                        <span class="table_del_btn"
                                @click="delRow(scope.row)">
                            <i class="el-icon-delete"></i>
                            删除
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="bottom_page" ref="bottom_page">
            <!-- --> <page-view @getTableList="handleCurrentChange"
                       :currentPage="currentPage"
                       :pageSize="pageSize"
                       :total="total"></page-view>
        </div>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";
    import {clone} from "@/global/utils";

    export default {
        name: "tableView",
        data() {
            const showHos = (row, column, cellValue, index) => {
                // return  `${row.province}/${row.city}/${row.region}`
                return  `${row.province}/${row.city}`
            };
            return {
                searchForm: {
                    input: '',
                    hos_search_cascader: [],
                },
                cascader_props: {
                    expandTrigger: 'hover',
                    value: 'name',
                    label: 'name',
                    children: 'city_list',
                },

                tableData: [],
                columnData: [
                    {label: '医院名称', prop: 'name'},
                    // {label: '医院级别', prop: 'level'},
                    {label: '医院编码', prop: 'code'},
                    {label: '医院地区', prop: 'region', formatter: showHos},
                    {label: '详细地址', prop: 'address'},
                ],
                total: 0,
                currentPage: 1,
                pageSize: 50,
            }
        },
        computed: {
            ...mapState("comInformationData", [
                'city_list'
            ])
        },
        mounted() {
            this.getTableData();
            this.$eventBus.$on("pollPort",() =>{
                this.getTableData()
            })
        },
        beforeDestroy() {
            this.$eventBus.$off('pollPort');
        },
        methods: {
            ...mapMutations('manageData', {
                setHosData: 'setHosData'
            }),
            addHos() {
                this.setHosData(null);
                this.$emit('changeTopTab', 'addView')
            },

            delRow(row) {
                this.$confirm('确定删除该医院么？').then(() => {
                    this.httpDel(`/hospital/${row.hospital_id}`).then(res => {
                        this.$message.success('删除成功！');
                        if (this.tableData.length === 1) {
                            let page = this.currentPage === 1 ? 1 : this.currentPage -1;
                            this.getTableData(page)
                        } else {
                            this.getTableData(this.currentPage)
                        }
                    })
                }).catch(() => {})
            },
            editRow(row) {
                this.httpGet(`/hospital/${row.hospital_id}`).then(res => {
                    this.setHosData(res.data);
                    this.$emit('changeTopTab', 'addView')
                })
            },

            handleCurrentChange(val) {
                this.getTableData(val)
            },
            getTableData(v = 1) {
                console.log('get_data');
                let params = {
                    name: this.searchForm.input,
                    province: this.searchForm.hos_search_cascader[0]?this.searchForm.hos_search_cascader[0]:'',
                    city: this.searchForm.hos_search_cascader[1]?this.searchForm.hos_search_cascader[1]:'',
                    page: v,
                    page_size: this.pageSize
                };
                this.httpGet('/hospital', params).then(res => {
                    this.tableData = res.data.data_list;
                    this.total = res.data.total;
                    this.$nextTick(() => {
                        this.currentPage = v
                    })
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>